import axios from 'axiosConfig';

export const deleteBorrowerType = (borrowerTypeID) => axios.delete(`/api/borrowertype/deleteborrowertype/${borrowerTypeID}`);

export const createBorrowerType = (newBorrowerType) => axios.post("/api/borrowertype/createborrowertype", newBorrowerType, {});

export const updateBorrowerType = (borrowerType) => axios.put("/api/borrowertype/updateborrowertype", borrowerType, {});

export const getAllBorrowerTypes = () => axios.get("/api/borrowertype/getborrowertypes", {});
export const unDeleteBorrowerType = (id) => axios.post("/api/borrowertype/undeleteborrowertype", { id });
